var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBgAirKeyStartsetSlider = function SvgBgAirKeyStartsetSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 320
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "BG-AirKey-Startset-slider_svg__b",
    cx: 0.5,
    cy: 0.5,
    r: 0.569,
    gradientTransform: "matrix(1 0 0 4.552 0 -1.776)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4a4a",
    stopOpacity: 0.204
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "BG-AirKey-Startset-slider_svg__a",
    x1: 0.505,
    x2: 0.504,
    y1: -0.771,
    y2: 1.731,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#b6b6b6",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#bcbcbc",
    stopOpacity: 0.082
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#949494",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4a4a",
    stopOpacity: 0.204
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#BG-AirKey-Startset-slider_svg__a)",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 320,
    fill: "url(#BG-AirKey-Startset-slider_svg__b)",
    rx: 3
  })));
};
export default SvgBgAirKeyStartsetSlider;